import queryString from "query-string";
import { useLocation } from "react-router-dom";
import { oauthAuthorize } from "../../api/oauth-authorize";

const getQueryParams = (search) => {
  const params = queryString.parse(search);
  return {
    approval_prompt: params.approval_prompt,
    client_id: params.client_id,
    redirect_uri: params.redirect_uri,
    response_type: params.response_type,
    state: params.state,
  };
};

export const useAuthorizeWithDoorkeeper = (setLoading, setCallOnce) => {
  const { search } = useLocation();

  // oauthAuthorize now triggers a full-page redirect via window.location.href
  // — the API does the OAuth handshake server-side and 302s back to the
  // client app. It returns undefined synchronously, so there's nothing to
  // await and no response data to forward. The previous implementation
  // awaited the call and read res.data.redirect_uri, which threw a
  // TypeError just before the page unloaded and surfaced as a spurious
  // "Network error" toast.
  const authorizeWithDoorkeeper = () => {
    setLoading(true);
    setCallOnce(true);
    oauthAuthorize(getQueryParams(search));
  };

  return authorizeWithDoorkeeper;
};
